import { head } from 'lodash';
import { StyleSheet } from 'react-native';

    const colors = {
        primaryBackground: '#011f41',
        secondaryBackground: '#f8eccc',
        accentColor: '#d97d27',
        textPrimary: 'white',
        textSecondary: 'gray',
        textProgressCompleted: '#006eb7',
        textProgressInProgress: '#399840',
        textProgressNotStarted: 'rgba(0, 0, 0, 0.30)',
        // textProgressNotStarted: 'rgba(210, 35, 42, 0.85)',
        // Add more colors as needed
    };

    const styles = StyleSheet.create({
    //Header styles
    header: {
        backgroundColor: '#011f41',
        shadowOpacity: 0
    },
    // headerTintColor: 'white',
    headerTitle: {
        fontWeight: 'bold',
        color: 'white'
    },
    headerButton: {
        marginLeft: 10,
        backgroundColor: '#d97d27',
        paddingHorizontal: 12,
        paddingVertical: 5,
        borderRadius: 20,
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
    },
    headerButtonText: {
        fontSize: 13,
        color: 'white',
        textTransform: 'uppercase',
    },
    //Reset Button style
    resetButton: {
        marginRight: 10,
        backgroundColor: '#d97d27',
        paddingHorizontal: 12,
        paddingVertical: 5,
        borderRadius: 20,
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5, 
    },
    resetButtonText: {
        fontSize: 13,
        color: 'white',
        textTransform: 'uppercase',
    },    
    // HomeScreen styles
    container: {
        paddingTop: 0,
        flex: 1,
        backgroundColor: 'white',
    },
    ccmcLogo: {
        marginTop: 30,
        marginBottom: 0,
        width: 200,
        height: 80,
        alignSelf: 'center',
    },
    introText: {
        padding: 15,
        paddingTop: 0,
        fontSize: 14,
        color: '#333',
        // backgroundColor: 'white',
    },
    contentContainer: {
        paddingTop: 5,
        paddingBottom: 5,
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
    },
    groupContainer: {
        marginVertical: 5,
        width: '100%',
        paddingLeft: 10,
        paddingRight: 10,
    },
    deckInfo: {
        width: '50%',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    progressInfo: {
        width: '50%',
        justifyContent: 'center',
        alignItems: 'flex-end',
        textAlign: 'right',
    },
    deckName: {
        // marginLeft: 5,
        fontSize: 17,
        fontWeight: 'bold',
        color: '#333',
    },
    deckGroup: {
        // marginLeft: 5,
        fontSize: 15,
        color: 'gray',
        textAlign: 'left',
        alignItems: 'center',
    },
    deckProgress: {
        fontSize: 13,
        // fontStyle: 'italic',
        // fontWeight: '500',
        color: '#006eb7',
        textAlign: 'center',
    },
    modalOuterContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.20)',
    },
    modalInnerContainer: {
        width: 270,
        padding: 0,
        // paddingBottom: 15,
        backgroundColor: '#edeeee',
        borderRadius: 15,
        justifyContent: 'center',
        alignItems: 'center',
    },
    modalQuestion: {
        // marginBottom: 5,
        padding: 17,
    },
    modalButtonWrapper: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderTopWidth: 0.25,
        borderTopColor: '#aeb3b5',
        // borderBottomWidth: '0.25',
        // borderBottomColor: '#aeb3b5',
    },
    modalTerm: {
        padding: 12,
        width: '50%',
        alignItems: 'center',
        borderRightWidth: 0.25,
        borderRightColor: '#aeb3b5',
    },
    modalDefinition: {
        width: '50%',
        alignItems: 'center',
    },
    modalCancel: {
        padding: 12,
        width: '100%',
        alignItems: 'center',
        borderTopWidth: 0.25,
        borderTopColor: '#aeb3b5',
    },
    modalButtonText: {
        fontSize: 18,
        color: '#007AFF',
    },

  // SearchScreen styles
  searchContainer: {
    backgroundColor: '#f8eccc',
  },
  highlighted: {
    backgroundColor: 'yellow',
  },
  textInput: {
    padding: 10,
    backgroundColor: 'white',
    borderColor: 'gray',
    borderWidth: 0,
    margin: 10,
    marginTop: 10,
    borderRadius: 5,
    color: '#333',
    },
    scrollContainer: {
        flex: 1, 
        position: 'relative',
    },
    scroll: {
        flex: 1
    },
    groupLetter: {
        backgroundColor: '#fbc22c',
        fontWeight: 'bold', 
        fontSize: 18, 
        padding: 10,
    },
    item: {
        padding: 15,
        paddingRight: 65,
        backgroundColor: '#fbf1e2',
    },
    itemEven: {
        backgroundColor: 'white'
    },
    itemTerm: {
        fontSize: 15,
        fontWeight: 'bold',
        color: '#333',
    },
    itemDefinition: {
        color: 'gray',
        marginTop: 5
    },
    lettersContainer: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 10,
        justifyContent: 'center',
        alignItems: 'flex-end'
    },
    letter: {
        backgroundColor: '#006eb7',
        borderRadius: 5,
        marginVertical: 2,
        justifyContent: 'center',
        alignItems: 'center',
        width: 25,
        height: 25
    },
    letterActive: {
        backgroundColor: '#011f41'
    },
    letterText: {
        fontSize: 16,
        color: 'white'
    },
    letterTextActive: {
        color: 'white'
    },

    // BottomNavBar styles
    navBarContainer: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        padding: 10,
        paddingBottom: 25,
        backgroundColor: '#011f41'
    },
    navButton: {
        width: 60,
        justifyContent: 'center',
        alignItems: 'center',
        opacity: 1,
    },
    navButtonDisabled: {
        justifyContent: 'center',
        alignItems: 'center',
        width: 60,
        opacity: 0.5,
    },
    navIcon: {
        width: 30,
        height: 30,
        justifyContent: 'center',
        alignItems: 'center',
    },
    navIconText: {
        marginTop: 3,
        fontSize: 12,
        color: 'white',
        textTransform: 'uppercase',
    },

    // GroupScreen styles
    homeButton: {
        width: 60,
        justifyContent: 'center',
        alignItems: 'center',
        opacity: 1,
    },
    homeIcon: {
        width: 25,
        height: 25,
    },
    animatedView: {
        flex: 1
    },
    centeredContainer: {
        paddingBottom: 150,
        flex: 1, 
        justifyContent: 'center', 
        alignItems: 'center',
        backgroundColor: '#006eb7'
    },
    labelStyle: {
        // marginBottom: 10,
        fontSize: 16,
        color: '#ffffff',
        textAlign: 'center',
        textTransform: 'uppercase',
        opacity: 0.75
    },
    boldText: {
        maxWidth: '85%',
        fontSize: 18,
        color: '#ffffff',
        textAlign: 'center'
    },
    toggleButtonContainer: {
        marginTop: 20
    },
    animatedText: {
        maxWidth: '85%',
        fontSize: 18,
        color: '#ffffff',
        textAlign: 'center'
    },
    navButtonContainer: {
        position: 'absolute',
        bottom: 180,
        justifyContent: 'center', 
        alignItems: 'center',
        zIndex: 100
    },
    navButtons: {
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        width: 150
    },
    bottomLeftText: {
        position: 'absolute', 
        bottom: 50, 
        left: 20,
        color: '#fff',
    },
    bottomRightText: {
        position: 'absolute', 
        bottom: 50, 
        right: 20,color: '#fff',
    },
    feedbackOverlay: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
    },    
    feedbackText: {
        fontSize: 32,
        color: 'white'
    }
});

// Percentage Screen styles
const percentageScreenStyles = StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    headerText: {
      fontSize: 24,
      marginBottom: 20,
      textAlign: 'center',
    },
    percentageContainer: {
      alignItems: 'center',
    },
    percentageText: {
      fontSize: 20,
      textAlign: 'center',
    },
    percentageIndicator: {
      width: 50,
      height: 10,
      borderRadius: 5,
      marginTop: 10,
    },
    counterText: {
      fontSize: 16,
      marginTop: 20,
      textAlign: 'center',
    },
    returnButton: {
      marginTop: 40,
      backgroundColor: '#d97d27',
      paddingVertical: 10,
      paddingHorizontal: 20,
      borderRadius: 20,
    },
    returnButtonText: {
      fontSize: 14,
      textAlign: 'center',
      textTransform: 'uppercase'
    },
});
  

export { colors, styles, percentageScreenStyles };